export const TEXT = "text"
export const IMAGE = "image"
export const VIDEO = "video"
export const GALLERY = "gallery"
export const COLUMN = "col"
export const ROW = "row"
export const BUTTON = "button"
export const SECTION = "container"
export const NAVBAR = "navbar"
export const NAVITEM = "navitem"
export const ICON = "icon"
export const SOCIAL_ICONS = "socialIcons"
export const SPACER = "spacer"
export const DIVIDER = "divider"
export const INLINE_APP = "inlineApp"
export const FORM = "form"
export const FORM_BUTTON = "formButton"
export const INPUT = "input"
export const SELECT = "select"
export const TEXTAREA = "textarea"
export const CHECKBOX_GROUP = "checkboxGroup"
export const RADIO_BUTTON_GROUP = "radioButtonGroup"
export const RECAPTCHA = "recaptcha"
export const REQUIRED_LABEL = "requiredLabel"

export const  DRAGGABLE_FORM_ELEMENTS = [
  FORM_BUTTON ,
  INPUT,
  SELECT,
  TEXTAREA,
  CHECKBOX_GROUP,
  RADIO_BUTTON_GROUP,
  RECAPTCHA,
  REQUIRED_LABEL,
]

export const  DRAGGABLE_COL_ELEMENTS = [
  TEXT,
  IMAGE,
  VIDEO,
  GALLERY,
  BUTTON,
  ICON,
  SOCIAL_ICONS,
  SPACER,
  DIVIDER,
  INLINE_APP,
  FORM,
]

export const HELP_LINKS = {
    "col": "http://help.moonfruit.com/responsive-editor/getting-started/responsive-editor-editing-the-page-layout",
    "row": "http://help.moonfruit.com/responsive-editor/getting-started/responsive-editor-editing-the-page-layout",
    "container": "http://help.moonfruit.com/responsive-pages-beta/guides/addingarranging-a-section",
    "image": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-an-image",
    "icon": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-an-icon",
    "text": "http://help.moonfruit.com/responsive-pages-beta/guides/addingediting-a-text-box",
    "button": "http://help.moonfruit.com/responsive-pages-beta/guides/addingediting-a-link-button",
    "navbar": "http://help.moonfruit.com/responsive-pages-beta/guides/editing-the-page-menu",
    "gallery": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-slideshow-or-gallery",
    "inlineApp": "http://help.moonfruit.com/the-responsive-editor-beta#widgets",
    "socialIcons": "http://help.moonfruit.com/the-responsive-editor-beta/widgets/responsive-editor-adding-social-icons",
    "spacer": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-spacer-or-divider",
    "divider": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-spacer-or-divider",
    "form": "http://help.moonfruit.com/responsive-pages-beta/guides/adding-a-contact-form"
}

export const YELL_HELP_LINKS = {
    "image": "http://intercom.help/yellsites/images/add-an-image",
    "icon": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-an-icon",
    "text": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-a-text-box",
    "button": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-a-link-button",
    "gallery": "http://intercom.help/yellsites/images/add-an-image-gallery",
    "socialIcons": "http://intercom.help/yellsites/social/add-social-icons",
    "spacer": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/spacer-or-page-divider",
    "divider": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/spacer-or-page-divider",
    "form": "http://intercom.help/yellsites/build-your-websitesite-with-the-responsive-editor/add-a-moonfruit-and-wufoo-contact-form"
}

export function getHelpLinkForElementType(type, partnerCode) {
    switch (partnerCode) {
      case 'yell':
        return YELL_HELP_LINKS[type] ? YELL_HELP_LINKS[type] : null;
        break
      case 'moonfruit':
        return HELP_LINKS[type] ? HELP_LINKS[type] : null;
        break
      default:
        return HELP_LINKS[type] ? HELP_LINKS[type] : null;
    }
}



// WEBPACK FOOTER //
// ./src/constants/ElementTypes.js